import { render, staticRenderFns } from "./GlobalRegions.vue?vue&type=template&id=69037984&"
import script from "./GlobalRegions.vue?vue&type=script&lang=js&"
export * from "./GlobalRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports